import { render } from "./DatosCompra.vue?vue&type=template&id=5a9adb5a&scoped=true"
import script from "./DatosCompra.vue?vue&type=script&lang=js"
export * from "./DatosCompra.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./DatosCompra.vue?vue&type=style&index=1&id=5a9adb5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9adb5a"]])

export default __exports__